import { getStoredViewAsRole, getStoredViewAsRoleTranslated, setStoredViewAsRole } from '@/utils/viewAsRole'

const App = {
  namespaced: true,

  state: {
    drawer: false,
    viewAsRoleName: getStoredViewAsRole(),
    viewAsRoleTranslated: getStoredViewAsRoleTranslated(),

    activeModalityId: null,
    activeModalitySolution: null,
    activeModalityName: null,
    activeDepotTk: null,
    activeDepotPix: null,
  },
  getters: {
    getDrawer: state => state.drawer,
    effectiveRoleName: state => state.viewAsRoleName,
    isViewingAsRole: state => !!state.viewAsRoleName,
  },
  mutations: {
    setDrawer(state, payload) {
      state.drawer = payload;
    },
    setDepot(state, modality_id){
      const local = localStorage.getItem('modality_id')
      if (modality_id){
        state.activeModalityId = modality_id
        localStorage.setItem('modality_id', state.activeModalityId)
      } else {
        state.activeModalityId = local
      }
    },
    setDepotName(state, modality_id){
      state.activeModalityName = modality_id
    },
    setDepotTk(state, depot_tk){
      const local = localStorage.getItem('depot_tk')
      if (depot_tk){
        state.activeDepotTk = depot_tk
        localStorage.setItem('depot_tk', state.activeDepotTk)
      } else {
        state.activeDepotTk = local
      }
    },
    setDepotPix(state, depot_company_pix){
      const local = localStorage.getItem('depot_company_pix')
      if (depot_company_pix){
        state.activeDepotPix = depot_company_pix
        localStorage.setItem('depot_company_pix', state.activeDepotPix)
      } else {
        state.activeDepotPix = local
      }
    },
    setSolution(state, modality_solution){
      if(modality_solution){
        state.activeModalitySolution = modality_solution
      }else{
        state.activeModalitySolution = null
      }
    },
    setViewAsRole(state, { name, translated }) {
      state.viewAsRoleName = name || null
      state.viewAsRoleTranslated = translated || null
    },
  },
  actions: {
    setDrawer(context, payload) {
      context.commit("setDrawer", payload);
    },
    setActiveDepotName(context, depot_name) {
      context.commit("setDepotName", depot_name);
    },
    setactiveModalityId(context, modality_id) {
      context.commit("setDepot", modality_id);
    },
    setactiveModalitySolution(context, modality_solution) {
      context.commit("setSolution", modality_solution);
    },
    setActiveDepotTk(context, depot_tk) {
      context.commit("setDepotTk", depot_tk);
    },
    setActiveDepotPix(context, depot_company_pix) {
      context.commit("setDepotPix", depot_company_pix);
    },
    setViewAsRole(context, payload) {
      setStoredViewAsRole(payload?.name || null, payload?.translated || null)
      context.commit('setViewAsRole', payload || { name: null, translated: null })
    },
    clearViewAsRole(context) {
      context.dispatch('setViewAsRole', { name: null, translated: null })
    },
  }
};

export default App;
